import React from "react";

import { Box } from "src/components";

import { Helmet } from "react-helmet";

const BanzaiCalculator = ({activity, title, ...props }) => (
  <Box {...props}>
    <Helmet>
      <script src="https://teachbanzai.com/coach/styles.js?subdomain=fcfcu" type="text/javascript" />
     </Helmet>

    <div
      id={activity}
      class="__banzai-coach"
    >
    </div>

  </Box>
);

export default BanzaiCalculator;

export const BanzaiCalculatorFragment = graphql`
  fragment BanzaiCalculator on ContentfulBanzaiCalculator {
    id
    __typename
    activity
    title: name
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/BanzaiCalculator.js